import {Box, CircularProgress} from '@mui/material';

import {TableRowScorePill} from '../../../../../components/TableRowScorePill/TableRowScorePill';

export interface Props {
  score: number | null | undefined;
  isAnalysisInProgress: boolean;
  analysisInProgressLabel: string;
}

export const WorkforceProfileRowScoreCell = ({
  score,
  isAnalysisInProgress,
  analysisInProgressLabel,
}: Props) => {
  if (isAnalysisInProgress) {
    return (
      <Box sx={{display: 'flex', justifyContent: 'center'}}>
        <CircularProgress
          size={16}
          color='inherit'
          aria-label={analysisInProgressLabel}
          sx={{color: 'text.disabled'}}
        />
      </Box>
    );
  }

  if (score != null) {
    return <TableRowScorePill score={score} />;
  }

  return (
    <Box component='span' sx={{color: 'text.disabled'}}>
      —
    </Box>
  );
};
